<script setup>
import { Link } from "@inertiajs/inertia-vue3";
import { Inertia } from '@inertiajs/inertia';

const logout = () => {
    Inertia.post('/logout')
}
</script>
<template>
    <nav
        class="lato fixed inset-x-0 bottom-0 bg-[#D7D4CE] w-full shadow-md z-50"
    >
        <div class="flex items-center px-5 h-16">
            <div
                class="flex-1 flex justify-center items-center gap-10"
            >
                <Link v-if="['staff', 'admin', 'super_admin'].includes($page.props.auth.user.role)"
                      href="/calendar"
                      class="text-center">
                    <i
                        :class="`${$page.url === '/calendar' || $page.url.startsWith('/calendar') ? ' text-[#8A4FFF] font-bold' : ''} pi pi-calendar`"
                    ></i>

                    <div class="text-sm">Kalender</div>
                </Link>

                <Link href="/anamnesis" class="text-center">
                    <i
                        :class="` ${$page.url === '/anamnesis' || $page.url.startsWith('/anamnesis') ? ' text-[#8A4FFF] font-bold' : ''} pi pi-file`"
                    ></i>

                    <div class="text-sm">Anamnese</div>
                </Link>

                <Link href="/customers" class="text-center">
                    <i
                        :class="`${$page.url === '/customers' || $page.url.startsWith('/customers') ? ' text-[#8A4FFF] font-bold' : ''} pi pi-users`"
                    ></i>

                    <div class="text-sm">Kunden</div>
                </Link>

                <Link v-if="['admin', 'super_admin'].includes($page.props.auth.user.role)"
                      href="/admin/users"
                      class="text-center">
                    <i
                        :class="`${$page.url.startsWith('/admin') ? ' text-[#8A4FFF] font-bold' : ''} pi pi-cog`"
                    ></i>

                    <div class="text-sm">Admin</div>
                </Link>

                <Link v-if="['admin', 'super_admin'].includes($page.props.auth.user.role)"
                      href="/management"
                      class="text-center">
                    <i
                        :class="`${$page.url.startsWith('/management') ? ' text-[#8A4FFF] font-bold' : ''} pi pi-warehouse`"
                    ></i>

                    <div class="text-sm">Management</div>
                </Link>
            </div>

            <div class="flex gap-3">
                <Link href="/profile/edit"
                      class="text-center cursor-pointer">
                    <i class="pi pi-user"></i>

                    <div class="text-sm">Profil</div>
                </Link>

                <div class="text-center cursor-pointer" @click="logout">
                    <i class="pi pi-sign-out"> </i>
                    <div class="text-sm">Abmeldung</div>
                </div>
            </div>
        </div>
    </nav>
</template>
